import {
  Box,
  Card,
  CardContent,
  Chip,
  Divider,
  Typography,
} from '@mui/material';
import ManualBotModal from 'app/components/Portfolio/ManualBotModal';
import PageHeader from 'app/design/speedBot/PageHeader';
import MuiButton from 'app/design/uiComponents/MuiButton';
import MuiChip from 'app/design/uiComponents/MuiChip';
import { useGetMediaQueryUp } from 'app/hooks/useGetMediaQuery';
import { useState } from 'react';
import { GetAllBots } from 'types/ApiServicesTypes';

type TradeIdeasBotSelectionProps = {
  signalBotsData: Array<GetAllBots>;
  handleClick: (selectedBot: GetAllBots) => void;
  handleCreateBot: (success: boolean) => void;
};

const TradeIdeasBotSelection = ({
  signalBotsData,
  handleClick,
  handleCreateBot,
}: TradeIdeasBotSelectionProps) => {
  const isMdUp = useGetMediaQueryUp('md');
  const [open, setOpen] = useState(false);
  const [hoveredBot, setHoveredBot] = useState<number>(0);
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <Box>
      <PageHeader
        variant="default"
        title={`Select Bots`}
        {...(isMdUp && { hideBackButton: true })}
      />
      <Box className="d-flex flex-column p-main-spacing">
        {signalBotsData.length > 0 ? (
          signalBotsData.map(bot => (
            <Card
              key={bot.botid}
              sx={{
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                transform:
                  hoveredBot === bot.botid ? 'translateY(-2px)' : 'none',
                boxShadow: hoveredBot === bot.botid ? 4 : 2,
                '&:hover': {
                  boxShadow: 4,
                },
                my: 1,
              }}
              onClick={() => handleClick(bot)}
              onMouseEnter={() => setHoveredBot(bot.botid)}
              onMouseLeave={() => setHoveredBot(0)}
            >
              <CardContent
                sx={{
                  padding: '16px !important',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      width: '100%',
                    }}
                  >
                    <Typography
                      variant="subtitle1"
                      sx={{
                        mb: 0.5,
                        color: 'text.primary',
                      }}
                    >
                      {bot.name}
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                      {bot.category && (
                        <MuiChip
                          label={bot.category}
                          size="small"
                          color={
                            bot.category === 'live'
                              ? 'successlight'
                              : bot.category === 'paper'
                              ? 'purplelight'
                              : bot.category === 'inactive'
                              ? 'warninglight'
                              : 'infolight'
                          }
                          // variant="outlined"
                        />
                      )}
                    </Box>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          ))
        ) : (
          <Box
            className="p-main-spacing d-flex flex-column"
            sx={{ margin: 4, marginTop: 0, justifyContent: 'center' }}
          >
            <Typography>
              You do not have a bot to execute this trade, so you should create
              one first.
            </Typography>
          </Box>
        )}
      </Box>
      <Box
        className="p-main-spacing d-flex flex-column"
        sx={{ margin: 4, marginTop: 3, justifyContent: 'center' }}
      >
        <MuiButton
          variant="contained"
          sx={{
            bgcolor: 'secondary.default',
            width: '100%',
          }}
          onClick={() => setOpen(true)}
          fullWidth={false}
        >
          + create
        </MuiButton>
      </Box>
      <ManualBotModal
        open={open}
        handleClose={handleClose}
        handleClick={handleCreateBot}
      />
    </Box>
  );
};

export default TradeIdeasBotSelection;
